module.exports = __webpack_public_path__ + "static/media/wavExtraFeeIcon.018a391b.svg";